/* eslint-disable */
import cookie from 'react-cookies';
import PropTypes from 'prop-types';
import profile1 from '../../common/noimage/no-uaser-small.png';
import profile from '../../common/noimage/no-user-big.png';
import noimage from '../../common/noimage/no-image.jpg';
import hmenu_user from "../../common/images-new/no-profile-pic.png";
import moment from 'moment';
import Resizer from 'react-image-file-resizer';
import htmlToDraft from "html-to-draftjs";
import { EditorState, ContentState } from "draft-js";
import $ from 'jquery';
import Swal from 'sweetalert2';
import { staticFiles } from './Static';
import { defaultTheme } from '../../pages/Theme';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';

/* stripslashes  */
export const stripslashes = function (str) {

	if (str !== '' && str !== null && str !== undefined) {
		str = str.replace(/\\|\//g, '');
	}
	return str;
};



export const checkauthentication = function () {
	if (localStorage.getItem('user_id') === null || localStorage.getItem('user_id') === undefined || localStorage.getItem('user_id') === '') {
		return false;
	}
	else {
		return true;
	}
};

export const getImage = function (pangeName) {
	if (typeof localStorage.getItem('profile_image') != 'undefined' && localStorage.getItem('profile_image') != '') {
		return localStorage.getItem('profile_image');
	}
	else {
		var imageUrl = '';
		if (pangeName == 'profile') {
			var imageUrl = profile;
		}
		else if (pangeName == 'header') {
			var imageUrl = profile1;
		}
		return imageUrl;
	}
};

export const LoadImage = function (imageLink) {
	if (imageLink !== '' && imageLink !== null) {
		return imageLink;
	}
	else {
		return hmenu_user;
	}
};

export const getName = function (pangeName) {
	if (typeof localStorage.getItem('name') != 'undefined' && localStorage.getItem('name') != '') {
		return localStorage.getItem('name');
	}
};

export const getEmail = function (pangeName) {
	if (typeof localStorage.getItem('email') != 'undefined' && localStorage.getItem('email') != '') {
		return localStorage.getItem('email');
	}
};

export const getProgramme = function () {
	if (typeof localStorage.getItem('programme') != 'undefined' && localStorage.getItem('programme') != '') {
		return localStorage.getItem('programme');
	}
};

export const dateFormat = function (date) {
	if (date != '') {
		var mydates = date;
		const timezone = require('moment-timezone');
		const formattedDT = moment.tz(mydates, 'Asia/Singapore').format('MM-DD-YYYY h:mm A');
		return formattedDT;
	}
};
export const analyticsDateTimeFormat = function (date) {
	if (date != '') {
		var mydates = date;
		const timezone = require('moment-timezone');
		const formattedDT = moment.tz(mydates, 'Asia/Singapore').format('DD MMM YYYY, h:mm A');
		return formattedDT;
	}
};
export const commentsDateFormat = function (date) {
	if (date != '') {
		var mydates = date;
		const timezone = require('moment-timezone');
		const formattedDT = moment.tz(mydates, 'Asia/Singapore').format('MM-DD-YYYY h:mm A');
		return formattedDT;
	}
};

export const displayTitle = function (str) {
	if (str != '') {
		const result = str.toLowerCase().replace(/\b[a-z]/g, function (letter) {
			return letter.toUpperCase();
		});
		return result;
	}
};

export const getLogindetails = function (value) {
	if (value != '') {
		localStorage.setItem("user_id", value.user_id);
		localStorage.setItem("name", value.name);
		localStorage.setItem("programme", value.programme);
		localStorage.setItem("secondary_email", value.secondary_email);
		localStorage.setItem("email", value.email);
		localStorage.setItem("token", value.token);
		localStorage.setItem("refreshToken", value.refreshToken);
		localStorage.setItem("profile_image", value.profile_image);
		localStorage.setItem("cover_image", value.cover_image);
		localStorage.setItem("user_type", value.user_type);
		localStorage.setItem("reference_id", value.reference_id);
		localStorage.setItem("gsuite_user_id", value.gsuite_user_id);


		return true;
	} else {
		return false;
	}
}


export const findNoImage = function (image) {

	if (image !== "") {
		let regex = new RegExp('[^.]+$');
		let extension = image.match(regex);
		if (extension[0] === "jpg" || extension[0] === "jpeg" || extension[0] === "png" || extension[0] === "gif" || extension[0] === "webp" || extension[0] === "PNG" || extension[0] === "JPG" || extension[0] === "JPEG" || extension[0] === "GIF" || extension[0] === "WEBP") {
			return image;
		} else {
			return "";
		}
	}
}



export const findUploadfiles = function (image) {

	if (image !== "") {
		let regex = new RegExp('[^.]+$');
		let extension = image.match(regex);
		if (extension[0] === "jpg" || extension[0] === "jpeg" || extension[0] === "png" || extension[0] === "gif" || extension[0] === "webp"
			|| extension[0] === "PNG" || extension[0] === "JPG" || extension[0] === "JPEG" || extension[0] === "GIF" || extension[0] === "WEBP") {
			return true;
		} else {
			return false;
		}
	}
}



export const findUploadpdffiles = function (files) {

	if (files !== "") {
		let regex = new RegExp('[^.]+$');
		let extension = files.match(regex);
		if (extension[0] === "pptx" || extension[0] === "doc" || extension[0] === "pdf" || extension[0] === "ppt" || extension[0] === "docx"
			|| extension[0] === "csv" || extension[0] === "xls" || extension[0] === "xlsx") {
			return true;
		} else {
			return false;
		}
	}
}



export const findRemoveImage = function (image) {

	if (image !== "") {
		let regex = new RegExp('[^.]+$');
		let extension = image.match(regex);
		if (extension[0] === "jpg" || extension[0] === "jpeg" || extension[0] === "png" || extension[0] === "gif" || extension[0] === "webp"
			|| extension[0] === "PNG" || extension[0] === "JPG" || extension[0] === "JPEG" || extension[0] === "GIF" || extension[0] === "WEBP") {
			return true;
		} else {
			return false;
		}
	}
}

export const convertToSlug = function (Text) {
	return Text
		.toLowerCase()
		.replace(/ /g, '-')
		.replace(/[^\w-]+/g, '');
}

export const htmlToText = (htmlString) => {
	const el = document.createElement('div');
	el.innerHTML = htmlString;
	return el.textContent;
}

export const removeIframe = (htmlString) => {
	var bufferText = htmlString;
	var div = $('<div />');
	div.append(bufferText);
	div.find('iframe').each(function () {
		$(this).remove();
	});
	// div.find('a').each(function () {
	// 	$(this).attr("target", "_blank");
	// });
	// div.find('a').each(function () {
	// 	$(this).remove();
	// });
	return div.html();
}

export const removeStrongEm = (htmlString) => {
	var div = $('<div />').html(htmlString);
	div.find('p:has(iframe) strong, p:has(iframe) em').contents().unwrap();
	div.find('p:has(iframe) em, p:has(iframe) strong').contents().unwrap();
	return div.html();
}


export const removeImage = (htmlString) => {
	var bufferText = htmlString;
	var div = $('<div />');
	div.append(bufferText);
	// div.find('img').each(function () {
	// 	$(this).remove();
	// });
	div.find('img').attr("width", "580");
	div.find('iframe').each(function () {
		$(this).remove();
	});
	// div.find('a').each(function () {
	// 	$(this).attr("target", "_blank");
	// });
	// div.find('a').each(function () {
	// 	$(this).remove();
	// });
	return div.html();
}

export const addAttribute = (htmlString) => {
	// var bufferText = htmlString;
	// var div = $('<div />');
	// div.append(bufferText);
	// // div.find('a').each(function () {
	// // 	$(this).attr("target", "_blank");
	// // });
	return htmlString;
}

export const htmlToText1 = (htmlString) => {
	return <div dangerouslySetInnerHTML={{ __html: addAttribute(htmlString) }} />;
}

export const trimString = (tagString, maxLength = 10) => {
	let retVal = "";
	if ((tagString === null) || (tagString === undefined)) return '';
	if (typeof tagString === 'string' || tagString instanceof String) {
		retVal = tagString?.substring(0, maxLength);
	}

	if (tagString?.length > maxLength) {
		retVal = retVal.slice(0, -3) + '...';
	}

	return retVal;
}

export const convertHtmlToDraft = (htmlString) => {
	const { contentBlocks, entityMap } = htmlToDraft(htmlString);
	const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
	return EditorState.createWithContent(contentState);
}

export const getProfilePic = (profPic) => {
	return (profPic && profPic.length > 0) ? profPic : hmenu_user
}

export const convertDate = (dbDate) => {
	// const monthNames =[
	//     "Jan", "Feb", "Mar", "Apr", "May", "Jun",
	//     "Jul","Aug", "Sep", "Oct","Nov","Dec"];

	// let postDate = new Date(dbDate);
	// let monthIndex = postDate.getMonth();
	// let monthName = monthNames[monthIndex];

	var postDate = new Date(dbDate).toLocaleDateString("en-GB", {
		year: "numeric",
		month: "2-digit",
		day: "2-digit",
	});

	//return `${postDate.getDate()} ${monthName} ${postDate.getFullYear()}`;
	return postDate;
}

export const convertDateFormat = (dbDate) => {

	var postDate = new Date(dbDate).toLocaleDateString("en-GB", {
		year: "numeric",
		month: "short",
		day: "numeric",
	});

	return postDate;
}


export const convertDateTime = (dbDate) => {

	var postDate = new Date(dbDate).toLocaleDateString("en-GB", {
		year: "numeric",
		month: "2-digit",
		day: "2-digit",
	});
	var postTime = new Date(dbDate).toLocaleTimeString();

	return `${postDate} ${postTime}`;
}

export const tokenAuthorize = (status) => {
	if (status == 401) {
		localStorage.clear();
		localStorage.setItem('autoLogout', 'session');
		window.location.pathname = "/";
	}
}

export const parseJwt = (token) => {
	var base64Url = token.split('.')[1];
	var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
	var jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function (c) {
		return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
	}).join(''));

	return JSON.parse(jsonPayload);
}

export const checkSecondaryLogin = (status) => {
	if (status == 500) {
		setInterval(() => {
			const elements = document.getElementsByClassName("swal2-popup");
			if (elements?.length > 0) {
				Array.from(elements).forEach((element) => {
					element.style.setProperty('--bg-swal-color', defaultTheme?.white);
					element.style.setProperty('--icon-swal-color', defaultTheme?.blue);
					element.style.setProperty('--title-swal-color', defaultTheme?.black);
					element.style.setProperty('--html-swal-color', defaultTheme?.gray);
					element.style.setProperty('--button-swal-color', defaultTheme?.buttonTopColor);
				});
			}
		}, 1)
		Swal.fire({
			title: "Info",
			text: "Your account is locked due to inactivity. To reactivate your account, please write to eportfolio@nie.edu.sg",
			icon: "warning"
		}).then((result) => {
			if (result.isConfirmed) {
				localStorage.clear();
				window.location = window.location.origin;
			}
		})
	}
}


export const showLoginError = (loginError) => {
	if (loginError) {
		setInterval(() => {
			const elements = document.getElementsByClassName("swal2-popup");
			if (elements?.length > 0) {
				Array.from(elements).forEach((element) => {
					element.style.setProperty('--bg-swal-color', defaultTheme?.white);
					element.style.setProperty('--icon-swal-color', defaultTheme?.blue);
					element.style.setProperty('--title-swal-color', defaultTheme?.black);
					element.style.setProperty('--html-swal-color', defaultTheme?.gray);
					element.style.setProperty('--button-swal-color', defaultTheme?.buttonTopColor);
				});
			}
		}, 1)
		Swal.fire({
			title: "Info",
			text: loginError == 'user_not_found' ? 'We couldn’t find your account' : 'Your account is not linked to MOE iCON',
			icon: "warning"
		})
	}
}

export const Loading = ({ active }) => {
	let style = active ? "w-7 h-7 mx-20" : "hidden w-7 h-7";
	return <img src={staticFiles.loading} alt="loading..." className={style} />;
};

export const analyticsView = "Click to view description";